document.addEventListener('bundler:bundle_widget_created', function(e) {
    // Select all product titles within the bundle widget
    var bundleProductTitles = document.querySelectorAll('.bndlr-product .bndlr-product-title');

    bundleProductTitles.forEach(function(titleElem) {
        var titleText = titleElem.textContent;

        if (titleText.length > 33) {
            titleElem.textContent = titleText.substring(0, 33) + '...';
        }
    });
});

//dadsa

/* =====================================================================
   NYTSTND unified Buy Now button (2026-10-15; pill shape + sentence case update same day)
   Shopify's dynamic checkout button switches between "Buy it now" and
   branded "Buy with Shop" per visitor, and can't be styled. Where it is
   enabled on a product form, we hide it (custom.css) and add our own
   BUY NOW button: adds the selected item (+ quantity/options) to the
   bag, then goes straight to checkout.
   ===================================================================== */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setup(wrap) {
    if (wrap.querySelector('.nyt-buy-now')) return;
    var dynamic = wrap.querySelector('.shopify-payment-button');
    var add = wrap.querySelector('.product-form__submit');
    var form = wrap.closest('form');
    if (!dynamic || !add || !form) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--full-width nyt-buy-now';
    btn.innerHTML = '<span>Buy Now</span>';

    var busy = false;
    var sync = function () { if (!busy) btn.disabled = add.hasAttribute('disabled'); };
    sync();
    new MutationObserver(sync).observe(add, { attributes: true, attributeFilter: ['disabled'] });

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var idInput = form.querySelector('[name="id"]');
      if (idInput) idInput.disabled = false;
      var data = new FormData(form);
      busy = true;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { window.location.href = root + 'checkout'; })
        .catch(function () {
          busy = false;
          btn.removeAttribute('aria-busy');
          sync();
          add.click(); // fall back to the normal Add to Bag flow (shows the theme's error message)
        });
    });

    dynamic.parentNode.insertBefore(btn, dynamic);
  }

  function scan() {
    document.querySelectorAll('.product-form__buttons').forEach(setup);
  }

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* =====================================================================
   NYTSTND multi-buy quantity sync (2026-10-16)
   On product pages with an AOV.ai "Buy More, Save More" volume offer:
   1. Moves the Quantity selector below the offer tiers.
   2. Choosing Buy 1 / 2 / 3 sets the quantity; changing the quantity
      (+, -, or typing) highlights the matching tier (3 = "3 or more").
   3. Add to bag and Buy Now add exactly the chosen quantity, tag the line
      for the offer and apply the offer's discount code (AOV.ai on its own
      always added the tier quantity and ignored the quantity box).
   Pages without an offer (e.g. QUAD) are not touched.
   Update 2026-10-16 (b):
   4. Offers now use "$ off" tiers (engraving fee is never discounted).
      Extra tiers Buy 4-10 exist only so the per-unit price holds for big
      quantities; they are hidden here so shoppers still see Buy 1/2/3.
   5. Every Add to bag (plain, multi-buy, engraved) opens the theme's
      cart popup instead of jumping to the cart page.
   ===================================================================== */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var syncingFromQty = false;

  /* 4. Show only Buy 1 / 2 / 3 */
  (function () {
    var css = '[id*="aov_ai_bundle_offer_volume"] .Avada-Volume__Item:nth-child(n+4){display:none!important}';
    var st = document.createElement('style');
    st.id = 'nyt-multibuy-css';
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  })();

  /* 5. Theme cart popup after any add to bag */
  function showCartPopup(key) {
    var cart = document.querySelector('loess-cart-notification');
    var popup = cart && cart.closest('loess-cart-notification-popup');
    if (!cart || !popup || !key || typeof cart.renderCartItems !== 'function') return Promise.resolve(false);
    cart.cartItemKey = key;
    var secs = cart.getSectionsToRender().map(function (s) { return s.section; });
    return Promise.all([
      fetch(window.location.pathname + '?sections=' + secs.join(',')).then(function (r) { return r.json(); }),
      fetch(root + 'cart.js').then(function (r) { return r.json(); })
    ]).then(function (res) {
      var state = res[1];
      // The engraving app edits the line right after adding it, which changes
      // its key; fall back to the newest line so the popup is never empty.
      var items = state.items || [];
      var found = items.some(function (it) { return it.key === key; });
      if (!found && items.length) key = items[0].key;
      cart.cartItemKey = key;
      state.key = key;
      state.sections = res[0];
      cart.renderCartItems(state);
      popup.open = true;
      if (popup.focus) popup.focus();
      return true;
    }).catch(function () { return false; });
  }
  window.nytShowCartPopup = showCartPopup;

  // Engraving add-on (Zepto personalizer) calls this hook after adding,
  // instead of sending the shopper to the cart page.
  window.pplr_update_minicart = function (item) {
    var key = item && (item.key || (item.items && item.items[0] && item.items[0].key));
    showCartPopup(key).then(function (ok) {
      if (!ok) window.location.href = root + 'cart';
      try {
        if (window.jQuery) {
          window.jQuery('.pplr_disabled').each(function () {
            if (!window.jQuery(this).parents('.pplr_no_preview')[0]) window.jQuery(this).prop('disabled', false).removeClass('pplr_disabled');
          });
        }
        if (typeof window.PPLR_CAlCULATE_PRICE === 'function') window.PPLR_CAlCULATE_PRICE();
      } catch (e) {}
    });
  };

  function productForm() {
    return document.querySelector('form[action*="/cart/add"].shopify-product-form') ||
      document.querySelector('product-form form[action*="/cart/add"]');
  }

  function productId() {
    var f = productForm();
    var el = f && f.querySelector('[name="product-id"]');
    return el ? String(el.value) : null;
  }

  function findOffer() {
    var b = window.AVADA_BUNDLE;
    var pid = productId();
    if (!b || !b.allOffers || !pid) return null;
    for (var i = 0; i < b.allOffers.length; i++) {
      var o = b.allOffers[i];
      if (o.type !== 'volume-discount' || o.status !== 'active' || !o.code) continue;
      var tp = o.triggerProducts || [];
      for (var j = 0; j < tp.length; j++) {
        if (String(tp[j] && (tp[j].id || tp[j])) === pid) return o;
      }
    }
    return null;
  }

  function qtyInput() {
    var f = productForm();
    if (f && f.id) {
      var q = document.querySelector('input[name="quantity"][form="' + f.id + '"]');
      if (q) return q;
    }
    return (f && f.querySelector('input[name="quantity"]')) || document.querySelector('.main-product__block-quantity-selector input[name="quantity"]');
  }

  function widgetBlock() {
    return document.querySelector('[id*="aov_ai_bundle_offer_volume"]');
  }

  function tierItems() {
    var block = widgetBlock();
    if (!block) return [];
    return Array.prototype.filter.call(block.querySelectorAll('.Avada-Volume__Item'), function (el) {
      return el.offsetParent !== null;
    });
  }

  function tierQty(el) {
    var m = (el.textContent || '').match(/Buy\s*(\d+)/i);
    return m ? parseInt(m[1], 10) : null;
  }

  /* 1. Quantity below the offer tiers */
  function moveQuantity() {
    var block = widgetBlock();
    var q = qtyInput();
    var qBlock = q && q.closest('.main-product__block-quantity-selector');
    if (!block || !qBlock || qBlock.dataset.nytMoved) return;
    block.parentNode.insertBefore(qBlock, block.nextSibling);
    qBlock.dataset.nytMoved = '1';
  }

  /* 2a. Tier chosen -> quantity */
  function onTierClick(e) {
    var item = e.target.closest && e.target.closest('.Avada-Volume__Item');
    if (!item || !widgetBlock() || !widgetBlock().contains(item)) return;
    if (syncingFromQty) return;
    var n = tierQty(item);
    var q = qtyInput();
    if (!n || !q) return;
    q.value = n;
    q.dispatchEvent(new Event('change', { bubbles: true }));
    ensureCodeFor(n);
  }

  /* 2b. Quantity changed -> highlight tier */
  function onQtyChange(e) {
    var q = qtyInput();
    if (!q || e.target !== q) return;
    var v = parseInt(q.value, 10);
    if (!v || v < 1) return;
    ensureCodeFor(v);
    var best = null, bestN = 0;
    tierItems().forEach(function (el) {
      var n = tierQty(el);
      if (n && n <= v && n > bestN) { best = el; bestN = n; }
    });
    if (best && !/--Selected/.test(best.className)) {
      syncingFromQty = true;
      best.click();
      syncingFromQty = false;
    }
  }

  /* 3. Add to bag / Buy Now with the chosen quantity */
  var busy = false;

  function jsonPost(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(path + ' failed'); return r.json(); });
  }

  // Put the offer's discount code on the cart, keeping any codes already there.
  function applyOfferCode(offer) {
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var codes = (cart.discount_codes || []).map(function (c) { return c.code; });
      if (codes.indexOf(offer.code) !== -1) return null;
      codes.push(offer.code);
      return jsonPost('cart/update.js', { discount: codes.join(',') });
    });
  }

  // Put the code on the cart as soon as the shopper picks 2 or more, so every
  // add-to-bag path (including the engraving add-on) gets the tier price.
  var codeQueued = false;
  function ensureCodeFor(qty) {
    if (codeQueued || !(qty >= 2)) return;
    var offer = findOffer();
    if (!offer) return;
    codeQueued = true;
    applyOfferCode(offer).catch(function () { codeQueued = false; });
  }

  // Tag the line for the offer (a hidden line-item property on the product form).
  function tagForm(form, offer) {
    var tag = form.querySelector('input[name="properties[_aov_bundles]"]');
    if (!tag) {
      tag = document.createElement('input');
      tag.type = 'hidden';
      tag.name = 'properties[_aov_bundles]';
      form.appendChild(tag);
    }
    tag.value = JSON.stringify({ offerId: offer.id });
  }

  function hasPersonalization(form) {
    var fd = new FormData(form);
    var found = false;
    fd.forEach(function (v, k) {
      if (/^properties\[/.test(k) && k !== 'properties[_aov_bundles]' && (typeof v !== 'string' || v !== '')) found = true;
    });
    return found;
  }

  function passThrough(btn) {
    btn.dataset.nytBypass = '1';
    btn.click();
    delete btn.dataset.nytBypass;
  }

  function intercept(e) {
    var btn = e.target.closest && e.target.closest('.product-form__submit, .nyt-buy-now');
    if (!btn || btn.disabled || btn.dataset.nytBypass) return;
    var form = productForm();
    if (!form || !(btn.form === form || form.contains(btn))) return;
    var offer = findOffer();
    if (!offer || !widgetBlock()) return;
    tagForm(form, offer);
    // Engraving on: the personalizer app swaps in its own Add to bag button and
    // only reacts to a real click, so leave that click alone (it already sends
    // the quantity box; the code was applied when 2+ was chosen).
    if (btn.classList.contains('pplr_cloned_atc')) {
      var qv = qtyInput();
      ensureCodeFor(parseInt((qv && qv.value) || '1', 10));
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    busy = true;
    btn.setAttribute('aria-busy', 'true');

    var isBuyNow = btn.classList.contains('nyt-buy-now');
    var done = function () { busy = false; btn.removeAttribute('aria-busy'); };

    // Engraving (personalizer) or Buy Now: apply the code, then let the normal
    // handler add the item - both read the quantity box correctly.
    if (isBuyNow || hasPersonalization(form)) {
      applyOfferCode(offer).catch(function () {}).then(function () { done(); passThrough(btn); });
      return;
    }

    // Plain Add to bag: add it ourselves, because AOV.ai would replace the
    // request with its selected tier quantity.
    var idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.disabled = false;
    var q = qtyInput();
    var qty = parseInt((q && q.value) || '1', 10);
    if (!qty || qty < 1) qty = 1;
    var id = Number(new FormData(form).get('id'));
    applyOfferCode(offer)
      .then(function () {
        return jsonPost('cart/add.js', { items: [{ id: id, quantity: qty, properties: { _aov_bundles: JSON.stringify({ offerId: offer.id }) } }] });
      })
      .then(function (res) {
        var key = res && res.items && res.items[0] && res.items[0].key;
        return showCartPopup(key).then(function (ok) {
          if (!ok) { window.location.href = root + 'cart'; return; }
          done();
        });
      })
      .catch(function () { done(); passThrough(btn); });
  }

  function onSubmit(e) {
    var form = productForm();
    if (e.target !== form || !findOffer() || !widgetBlock()) return;
    var btn = form.querySelector('.product-form__submit');
    if (!btn || btn.dataset.nytBypass) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.click();
  }

  function init() {
    var offer = findOffer();
    var form = productForm();
    if (!offer || !form) return;
    moveQuantity();
    tagForm(form, offer);
  }

  window.addEventListener('click', intercept, true);
  window.addEventListener('submit', onSubmit, true);
  document.addEventListener('click', onTierClick, false);
  document.addEventListener('change', onQtyChange, true);
  document.addEventListener('input', onQtyChange, true);

  init();
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
})();
